import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { SERVICE_URL } from '../Service';
import { RootState } from '../store';

interface State {
    isLoading: boolean;
    error: any;
    loginDetails: any;
    newFlow: any;
    commonResponse: object;
    returnAll: object;
    disposition: object;
    uploadFile: object;
}
const initialState: State = {
    isLoading: false,
    error: null,
    loginDetails: {},
    newFlow: {
        basic_ui_details: {},
        question_flow: [],
        ui_details: [],
        common_response_category: [],
        common_response_ui: []
    },
    commonResponse: {},
    returnAll: {},
    disposition: {},
    uploadFile: {}
}

const slice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        clearLoginDetails: (state, action) => {
            state.loginDetails = {};
        },
        createBasicUi: (state, action) => {
            state.newFlow.basic_ui_details = action.payload;
        },
        createQuestionFlow: (state, action) => {
            state.newFlow.question_flow = action.payload;
        },
        createUiDetails: (state, action) => {
            state.newFlow.ui_details = action.payload;
        },
        createCommonResCat: (state, action) => {
            state.newFlow.common_response_category = action.payload;
        },
        createCommonResUi: (state, action) => {
            state.newFlow.common_response_ui = action.payload;
        },
        clearNewFlow: (state, action) => {
            state.newFlow = {};
        },
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(GetLoginDetails.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(GetLoginDetails.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.loginDetails = action.payload;
        }).addCase(GetLoginDetails.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })

        builder.addCase(GetCommonResponse.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(GetCommonResponse.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.commonResponse = action.payload;
        }).addCase(GetCommonResponse.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })

        builder.addCase(GetReturnAll.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(GetReturnAll.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.returnAll = action.payload;
        }).addCase(GetReturnAll.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })

        builder.addCase(GetDisposition.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(GetDisposition.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.disposition = action.payload;
        }).addCase(GetDisposition.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })

        builder.addCase(GetUploadFile.pending, (state, action) => {
            state.isLoading = true;
        }).addCase(GetUploadFile.fulfilled, (state, action) => {
            // Add user to the state array
            state.isLoading = false
            state.uploadFile = action.payload;
        }).addCase(GetUploadFile.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error
        })
    }
})

// Action creators are generated for each case reducer function
export const { clearLoginDetails, createBasicUi, createQuestionFlow, createUiDetails, createCommonResCat, createCommonResUi, clearNewFlow } = slice.actions
export const commonData = (state: RootState) => state.common;
export default slice.reducer;


export const GetLoginDetails = createAsyncThunk(
    'common/GetLoginDetails',
    async (payload: any, thunkAPI) => {
        const response = await axios.post(SERVICE_URL.LOGIN, payload)
        return response.data;
    }
);

export const GetCommonResponse = createAsyncThunk(
    'common/GetCommonResponse',
    async (payload: any, thunkAPI) => {
        const response = await axios.post(SERVICE_URL.GET_COMMONRESPONSE, payload)
        return response.data;
    }
);

export const GetReturnAll = createAsyncThunk(
    'common/GetReturnAll',
    async (payload: any, thunkAPI) => {
        const response = await axios.get(SERVICE_URL.GET_RETURNALL, payload)
        return response.data;
    }
);

export const GetDisposition = createAsyncThunk(
    'common/GetDisposition',
    async (payload: any, thunkAPI) => {
        const response = await axios.post(SERVICE_URL.GET_DISPOSITION, payload)
        return response.data;
    }
);

export const GetUploadFile = createAsyncThunk(
    'common/GetUploadFile',
    async (payload: any, thunkAPI) => {
        const response = await axios.post(SERVICE_URL.INSERT_FILE, payload)
        return response.data;
    }
);